import React from 'react';
import { PersonalizedComponentMapper } from '../PersonalizedComponentMapper/ComponentMapper.lazy';
import { PersonalizedSectionCommonPropTypes } from '../shared/propTypes/personalizedSection.propTypes';
import PersonalizedSectionCommon from './common';

const PersonalizedSection = (props) => (
    <PersonalizedSectionCommon {...props} PersonalizedComponentMapper={PersonalizedComponentMapper} />
);

PersonalizedSection.propTypes = PersonalizedSectionCommonPropTypes;

export default PersonalizedSection;
